const Url = {
    questionUrl: "这是问答地址",
    /* 课程视频 */
    cCourseVideoUrl: 'https://app6132.acapp.acwing.com.cn/api/courseVideo/create/',
    rCourseVideoUrl: 'https://app6132.acapp.acwing.com.cn/api/courseVideo/read/',
    rOneCourseVideoUrl: 'https://app6132.acapp.acwing.com.cn/api/courseVideo/read/one/',
    dCourseVideoUrl: 'https://app6132.acapp.acwing.com.cn/api/courseVideo/delete/',
    uCourseVideoUrl: 'https://app6132.acapp.acwing.com.cn/api/courseVideo/update/',
    /* 题目题解视频 */
    cProblemVideoUrl: 'https://app6132.acapp.acwing.com.cn/api/problemVideo/create/', // 因为是1对1 所以创建和修改放在一起
    rProblemVideoUrl: 'https://app6132.acapp.acwing.com.cn/api/problemVideo/read/',
    dProblemVideoUrl: 'https://app6132.acapp.acwing.com.cn/api/problemVideo/delete/',
    /* 创建竞赛 */
    cCompeteUrl: 'https://app6132.acapp.acwing.com.cn/api/compete/create/',
    rCompeteUrl: 'https://app6132.acapp.acwing.com.cn/api/compete/read/',
    rOneCompeteUrl: 'https://app6132.acapp.acwing.com.cn/api/compete/read/one/',
    sCompeteUrl: 'https://app6132.acapp.acwing.com.cn/api/compete/select/',
    dCompeteUrl: 'https://app6132.acapp.acwing.com.cn/api/compete/delete/',
    uCompeteUrl: 'https://app6132.acapp.acwing.com.cn/api/compete/update/',
    /* 添加竞赛试题 */
    cCompeteProblemUrl: 'https://app6132.acapp.acwing.com.cn/api/competeProblem/create/',
    rCompeteProblemUrl: 'https://app6132.acapp.acwing.com.cn/api/competeProblem/read/',
    dCompeteProblemUrl: 'https://app6132.acapp.acwing.com.cn/api/competeProblem/delete/',
    uCompeteProblemUrl: 'https://app6132.acapp.acwing.com.cn/api/competeProblem/update/',
    /* 获取排名 */
    rAllRankUrl: 'https://app6132.acapp.acwing.com.cn/api/rank/read/all/',
    /* 报名竞赛 */
    cRegisterCompete: 'https://app6132.acapp.acwing.com.cn/api/competeRegister/create/',
    rRegisterCompete:'https://app6132.acapp.acwing.com.cn/api/competeRegister/read/',
    dRegisterCompete: 'https://app6132.acapp.acwing.com.cn/api/competeRegister/delete/',
    /* 课程发帖表 */
    cCourseTalkUrl: 'https://app6132.acapp.acwing.com.cn/api/courseTalk/create/',
    rCourseTalkUrl: 'https://app6132.acapp.acwing.com.cn/api/courseTalk/read/',
    dCourseTalkUrl: 'https://app6132.acapp.acwing.com.cn/api/courseTalk/delete/',
    /* 课程帖子回复表 */
    cCourseReplyUrl: 'https://app6132.acapp.acwing.com.cn/api/courseReply/create/',
    rCourseReplyUrl: 'https://app6132.acapp.acwing.com.cn/api/courseReply/read/',
    dCourseReplyUrl: 'https://app6132.acapp.acwing.com.cn/api/courseReply/delete/',
    /* 讨论区发帖表 */
    cPostMessageUrl: 'https://app6132.acapp.acwing.com.cn/api/postMessage/create/',
    rPostMessageUrl: 'https://app6132.acapp.acwing.com.cn/api/postMessage/read/',
    dPostMessageUrl: 'https://app6132.acapp.acwing.com.cn/api/postMessage/delete/',
    /* 讨论区帖子回复表 */
    cReplyMessageUrl: 'https://app6132.acapp.acwing.com.cn/api/messageReply/create/',
    rReplyMessageUrl: 'https://app6132.acapp.acwing.com.cn/api/messageReply/read/',
    dReplyMessageUrl: 'https://app6132.acapp.acwing.com.cn/api/messageReply/delete/',
    /* 竞赛搜索功能 */
    SearchCompeteUrl: 'https://app6132.acapp.acwing.com.cn/api/compete/search/',
    /* 讨论区主贴点赞功能 */
    cLikeMessageUrl: 'https://app6132.acapp.acwing.com.cn/api/message/like/create/',
    rLikeMessageUrl: 'https://app6132.acapp.acwing.com.cn/api/message/like/read/',
    uLikeMessageUrl: 'https://app6132.acapp.acwing.com.cn/api/message/like/update/',
    /* 统计竞赛功能 */
    CountCompeteUrl: 'https://app6132.acapp.acwing.com.cn/api/compete/count/',
    /* 好友消息表 */
    rFriendMessageUrl: 'https://app6132.acapp.acwing.com.cn/api/friendMessage/read/',
    /* 获取订单表 */
    rOrderUrl: 'https://app6132.acapp.acwing.com.cn/api/orders/read/',
    /* 题解表 */
    rAllNotesUrl: 'https://app6132.acapp.acwing.com.cn/api/notes/read/all/',
    /* 管理用户 */
    rUserUrl: 'https://app6132.acapp.acwing.com.cn/api/user/read/',
    dUserUrl: 'https://app6132.acapp.acwing.com.cn/api/user/delete/',
    SearchUserUrl: 'https://app6132.acapp.acwing.com.cn/api/user/search/',
    /* 订单功能 */
    rOrdersSalaryUrl: 'https://app6132.acapp.acwing.com.cn/api/ordersSalary/read/',
    rOneOrdersUrl: 'https://app6132.acapp.acwing.com.cn/api/orders/read/one/',
    
}

export default Url;